import { Component, inject, Input, OnChanges, OnDestroy } from '@angular/core';
import { BrandingHeader } from '../branding-header/branding-header';
import { BrandDetails } from '../models/Loa';
import { LoaService } from '../service/loa/loa';
import { InfoBox } from '../info-box/info-box';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { environment } from '../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Footer } from '../footer/footer';

@Component({
  selector: 'app-loa-submitted',
  imports: [
    BrandingHeader,
    InfoBox,
    FaIconComponent,
    Footer,
  ],
  templateUrl: './loa-submitted.component.html',
  styleUrl: './loa-submitted.component.scss'
})
export class LoaSubmittedComponent implements OnChanges, OnDestroy {
  @Input() brandDetails!: BrandDetails | null;
  @Input() pdfFile: File | null = null;
  @Input() isRenewal = false;

  public loaService = inject(LoaService);
  private sanitizer = inject(DomSanitizer);
  readonly loginLink = environment.LOGIN_PRODUCT_LINK;

  pdfObjectUrl: string | null = null;
  safePdfUrl: SafeResourceUrl | null = null;

  /**
   * Revokes any existing PDF object URL and creates a new one whenever `pdfFile` changes,
   * producing a sanitised `SafeResourceUrl` for embedding in the template.
   */
  ngOnChanges(): void {
    this.revokePdfUrl();
    if (this.pdfFile) {
      this.pdfObjectUrl = URL.createObjectURL(this.pdfFile);
      this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfObjectUrl + '#zoom=page-width');
    }
  }

  /** Triggers a browser download of the LOA PDF using the current object URL. */
  downloadPdf(): void {
    if (!this.pdfFile || !this.pdfObjectUrl) return;
    const a = document.createElement('a');
    a.href = this.pdfObjectUrl;
    a.download = this.pdfFile.name;
    a.click();
  }

  /** Revokes the PDF object URL on component destroy to prevent memory leaks. */
  ngOnDestroy(): void {
    this.revokePdfUrl();
  }

  /** Revokes the current `pdfObjectUrl` and nulls it out. */
  private revokePdfUrl(): void {
    if (this.pdfObjectUrl) {
      URL.revokeObjectURL(this.pdfObjectUrl);
      this.pdfObjectUrl = null;
    }
  }
}
